import {
  intlShape,
  loginContainer,
  ProgressTick,
  SubmitButton,
  utils,
} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {FormattedMessage, defineMessages, injectIntl} from 'react-intl';

import stylesButton from './SaveDeleteButtons.less';

const I18N = defineMessages({
  REMOVE: {
    id: 'autoLayout.button.remove',
    defaultMessage: 'Delete',
    description: 'title text for auto layout remove button',
  },
});

const ScreenRemoveButton = ({intl, isDisabled, isRemoving, onDelete}) => (
  <SubmitButton
    className={classNames(
      stylesButton.dlSaveDeleteButtonsButton,
      'btn-danger',
      'float-start'
    )}
    dataName={'removeScreenButton'}
    isPrimary={false}
    isDanger
    onClick={onDelete}
    disabled={isDisabled}
    title={utils.TranslateUtils.translate(I18N.REMOVE, intl)}
  >
    <ProgressTick progressCounter={+isRemoving}>
      <i
        className={classNames(
          stylesButton.dlButtonIcon,
          'fas fa-trash-alt fa-fw'
        )}
      />
      <span className={stylesButton.dlBoldText}>
        <FormattedMessage {...I18N.REMOVE} />
      </span>
    </ProgressTick>
  </SubmitButton>
);

ScreenRemoveButton.displayName = 'ScreenRemoveButton';

ScreenRemoveButton.propTypes = {
  onDelete: PropTypes.func,
  intl: intlShape.isRequired,
  isDisabled: PropTypes.bool,
  isRemoving: PropTypes.bool,
};

ScreenRemoveButton.defaultProps = {
  onDelete: undefined,
  isDisabled: false,
  isRemoving: false,
};

export default injectIntl(ScreenRemoveButton);
